import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Order Item Description Wrapper',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCheckoutOrderItem', rule: 'ExactlyOne'}],
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
